import React from "react";
import ReactSelect from "react-select";

import { selectStyle, selectTheme } from "./settings";
import { useNormalizer, WpTermToSelectOption } from "../utils";

/**
 * Configuration
 */
import config from "../config";
const { texts } = config;

const MultiSelect = ({
	label,
	placeholder,
	options,
	selected,
	setSelected,
}) => {
	const normalizedOptions = useNormalizer(options, WpTermToSelectOption);

	if (!normalizedOptions || !normalizedOptions.length) return null;

	return (
		<div className="multiselect">
			{/* <div className="multiselect__label input-label">{label}</div> */}
			<ReactSelect
				isMulti
				placeholder={placeholder}
				noOptionsMessage={() => texts.no_options}
				value={normalizedOptions.filter((option) =>
					selected.includes(option.value)
				)}
				options={normalizedOptions}
				onChange={(selected) => setSelected(selected.map(({ value }) => value))}
				styles={selectStyle}
				theme={selectTheme}
			/>
		</div>
	);
};

export default MultiSelect;
